import { render } from "./CookieConsentManager.vue?vue&type=template&id=81cc8ee8&scoped=true"
import script from "./CookieConsentManager.vue?vue&type=script&lang=js"
export * from "./CookieConsentManager.vue?vue&type=script&lang=js"

import "./CookieConsentManager.vue?vue&type=style&index=0&id=81cc8ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cc8ee8"]])

export default __exports__